module.exports = __webpack_public_path__ + "img/car_shina2_43.431d5a0f.jpg";